export const getShopByLookSlideKey = (title: string | undefined, index: number): string => `${title ?? 'slide'}-${index}`;
